<script setup>
import { ref, watch } from "vue";
import ModalDialogComponent from "@erp/shared/components/ui/Dialog/ModalDialogComponent.vue";

// Define incoming props
const { dialogValue, hideOverlay } = defineProps({
  dialogValue: {
    type: Boolean,
    default: false,
  },
  hideOverlay: {
    type: Boolean,
    default: false,
  },
});

// Local reactive states synced with prop
const loadingDialog = ref(dialogValue);
watch(
  () => dialogValue,
  (val) => {
    loadingDialog.value = val;
  },
);
</script>

<template>
  <div>
    <ModalDialogComponent
      :dialog-value="loadingDialog"
      persistent
      :hide-overlay="hideOverlay"
      max-width="300px"
      title-class="hide"
    >
      <v-progress-circular
        :size="120"
        :width="20"
        color="blue-grey lighten-3"
        indeterminate
        style="left: 50%; margin-left: -60px"
      ></v-progress-circular>
      <p class="mt-15 mb-0 text-h4 text-center grey--text text--lighten-1">
        LOADING...
      </p>
    </ModalDialogComponent>
  </div>
</template>

<style scoped>
/* 필요한 스타일이 있으면 여기에 추가하세요 */
</style>
